import React, { useRef } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { setProductPopup, searchProductForSelect, searchProducts4Invoice, setImagePopup } from "../store/api/GetAllProduct";
import { CardImage, X } from "react-bootstrap-icons";
import { invoiceTypes } from '../../store/api/CommonFunctions';
const ModalProducts = (props) => {
    const { productGrouppingType } = props;
    const openProductPop = useSelector(state => state.popup?.openProductPop);
    const selectedProductList = useSelector(state => state.customerDataReducer.selectedProductList);
    const usedPartsList = useSelector(state => state.service.usedPartsList);
    const purchaseProductList = useSelector(state => state.ProductRequestReducer.purchaseProductList);
    const searchData = useRef({});
    const dispatch = useDispatch();
    let imageclicked = false;
    const handleModal = () => {
        dispatch(setProductPopup({ status: 'hide' }));
    }
    const search = () => {
        let productCode = searchData.current.Code ?? "";
        productCode = productCode.replace(/\s/g, '');
        let productName = searchData.current.Name ?? "";
        productName = productName.replace(/\s/g, '');
        let productModel = searchData.current.Model ?? "";
        productModel = productModel.replace(/\s/g, '');
        let holder = searchData.current.HolderName ?? "";
        holder = holder.replace(/\s/g, '');
        if (productCode === '' && productName === '' && productModel === '' && holder === '') {
            alert('هیچکدام از کادرهای جستجو پر نشده است');
            return;
        }
        if (openProductPop.search4Purchase) {
            let data = {};
            data.Name = productName;
            data.Model = productModel;
            data.KalaCode = productCode;
            dispatch(searchProducts4Invoice(data,invoiceTypes.Purchase));
        }
        else {
            searchData.current.Take = 5;
            searchData.current.InService = true;
            dispatch(searchProductForSelect(searchData.current));
        }
    }
    const select = (item) => {
        if (imageclicked) {
            imageclicked = false;
            return;
        }
        var data = {};
        data.ProductID = item.ID;
        data.ProductName = item.Name;
        data.ProductModel = item.Model;
        data.HolderName = item.HolderName;
        data.UnitPrice = item.LastPurchasePrice ?? 0;
        data.SuggestedCount = item.SuggestedCount ?? 0;
        if (openProductPop.setProductData) {
            openProductPop.setProductData(data);
        }
        dispatch(setProductPopup({ status: 'hide' }));
    }
    const magnify = (image) => {
        if (image) {
            imageclicked = true;
            dispatch(setImagePopup({ status: "show", image: image }));
        }
    }
    const selectPart = (item) => {
        if (imageclicked) {
            imageclicked = false;
            return;
        }
        var data = {};
        data.StorageID = item.StorageID;
        data.ProductID = item.ID;
        data.ProductName = item.Name;
        data.ProductModel = item.Model;
        data.UnitPrice = openProductPop.isGuarantee === true ? item.GauranteeSalePrice : item.LastSalePrice;
        data.SuggestedCount = item.SuggestedCount < 0 ? 1 : item.SuggestedCount;
        openProductPop.setProductData(data);
        dispatch(setProductPopup({ status: 'hide' }));
    }
    return (
        <Modal size="lg" show={openProductPop.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}>انتخاب کالا از لیست<span onClick={handleModal} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body>
                <div className="row">
                    {(Number(productGrouppingType) === 1 || openProductPop.searchParts) &&
                        <div className="form-group col-md-4">
                            <input type="text" placeholder="کد کالا" className="form-control" onChange={e => searchData.current.Code = e.target.value} />
                        </div>
                    } {Number(productGrouppingType) !== 1 && !openProductPop.searchParts &&
                        <div className="form-group col-md-4">
                            <input type="text" placeholder="مارک کالا" className="form-control" onChange={e => searchData.current.HolderName = e.target.value} />
                        </div>
                    }
                    <div className="form-group col-md-4">
                        <input type="text" placeholder={(Number(productGrouppingType) === 1 || openProductPop.searchParts) ? ('نام کالا') : ('نوع کالا')} className="form-control" onChange={e => searchData.current.Name = e.target.value} />
                    </div>
                    <div className="form-group col-md-4">
                        <input type="text" placeholder="مدل کالا" className="form-control" onChange={e => searchData.current.Model = e.target.value} />
                    </div>
                </div>
                <button type="button" className="btn btn-primary w-100 mt-2" onClick={search}>جستجو</button>
                <br />
                <br />
                {selectedProductList && !openProductPop.searchParts && !openProductPop.search4Purchase &&
                    <Table>
                        <thead>
                            <tr style={{ padding: "0" }}>
                                <th style={{ display: "none" }}></th>
                                {Number(productGrouppingType) !== 1 && <th>مارک کالا</th>}
                                <th>{Number(productGrouppingType) === 1 ? "نام کالا" : "نوع کالا"}</th>
                                <th>مدل کالا</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(selectedProductList) && selectedProductList.map((item, i) => {
                                return (
                                    <tr className='resultTableRow' key={i} onClick={() => select(item)}>
                                        <td style={{ display: "none" }}></td>
                                        {Number(productGrouppingType) !== 1 && <td>{item?.HolderName}</td>}
                                        <td>{item?.Name}</td>
                                        <td>{item?.Model}</td>
                                    </tr>)
                            })
                            }
                        </tbody>
                    </Table>}

                {usedPartsList && openProductPop.searchParts && !openProductPop.search4Purchase &&
                    <Table>
                        <thead>
                            <tr style={{ padding: "0" }}>
                                <th style={{ display: "none" }}></th>
                                <th>نام قطعه</th>
                                <th>مدل قطعه</th>
                                <th>نام انبار</th>
                                <th style={{ textAlign: "center" }} title="تصویر کالا"><CardImage size={20} /></th>                                
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(usedPartsList) && usedPartsList.map((item, i) => {
                                return (
                                    <tr className='resultTableRow' key={i} onClick={() => selectPart(item)}>
                                        <td style={{ display: "none" }}></td>
                                        <td>{item?.Name}</td>
                                        <td>{item?.Model}</td>
                                        <td>{item.StorageName}</td>
                                        <td style={{ padding: "2px", width: "65px", cursor: item?.ProductImage ? "zoom-in" : "pointer" }} onClick={() => magnify(item?.ProductImage)}>
                                            {item && item.ProductImage && <img src={"data:image;base64," + item?.ProductImage} atl='' style={{ height: "35px", display: "block", margin: "auto" }} />}
                                        </td>                                        
                                    </tr>)
                            })
                            }
                        </tbody>
                    </Table>}

                {purchaseProductList && !openProductPop.searchParts && openProductPop.search4Purchase &&
                    <Table>
                        <thead>
                            <tr style={{ padding: "0" }}>
                                <th style={{ display: "none" }}></th>
                                <th>{Number(productGrouppingType) === 1 ? "نام کالا" : "نوع کالا"}</th>
                                <th>مدل کالا</th>
                                <th style={{ textAlign: "center" }} title="تصویر کالا"><CardImage size={20} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(purchaseProductList) && purchaseProductList.map((item, i) => {
                                return (
                                    <tr className='resultTableRow' key={i} onClick={() => select(item)}>
                                        <td style={{ display: "none" }}></td>
                                        <td>{item?.Name}</td>
                                        <td>{item?.Model}</td>
                                        <td style={{ padding: "2px", width: "65px", cursor: item?.ProductImage ? "zoom-in" : "pointer" }} onClick={() => magnify(item?.ProductImage)}>
                                            {item && item.ProductImage && <img src={"data:image;base64," + item?.ProductImage} atl='' style={{ height: "35px", display: "block", margin: "auto" }} />}
                                        </td>
                                    </tr>)
                            })
                            }
                        </tbody>
                    </Table>}
            </Modal.Body>
        </Modal >
    )
}
export default ModalProducts;